import React from "react";

//@ts-ignore
import logo from "../assets/images/logo-light.svg";

export default function Footer() {
  return (
    <footer id="main-footer">
      <div className="container">
        <div className="row">
          <div className="footer-wrapper">
            <div className="column">
              <div className="footer-logo">
                <img src={logo} />
              </div>
            </div>
            <div className="column">
              <div className="links">
                <h4>Utile</h4>
                <ul>
                  <li key={1}>
                    <a href="/">Acasa</a>
                  </li>
                  <li key={2}>
                    <a href="/despre-noi">Despre Noi</a>
                  </li>
                  <li key={3}>
                    <a href="/cookies">Politica Cookies</a>
                  </li>
                  <li key={4}>
                    <a href="/confidentialitate">
                      Politică de Confidențialitate
                    </a>
                  </li>
                  <li key={5}>
                    <a href="/#contact">Contact</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="column">
              <div className="links">
                <h4>Contact</h4>
                <div className="contact-footer-wrapper">
                  <div className="item">
                    <div className="icon-wrapper">
                      <i className="fa-solid fa-location-dot"></i>
                    </div>
                    <p>Str. Tăbăcarilor, nr. 2, Cluj-Napoca</p>
                  </div>
                  <div className="item">
                    <div className="icon-wrapper">
                      <i className="fa-solid fa-phone"></i>
                    </div>
                    <p>+40758928165</p>
                  </div>
                  <div className="item">
                    <div className="icon-wrapper">
                      <i className="fa-solid fa-envelope"></i>
                    </div>
                    <p>info@asempera.ro</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p className="copyright">
              © {new Date().getFullYear()} Asempera.ro - Proiectare și
              consultanță Smart Home Cluj-Napoca
            </p>

            <div className="social">
              {/* <a target="_blank" href="#">
                <i className="fa-brands fa-facebook"></i>
              </a> */}
              <a target="_blank" href="https://www.instagram.com/asempera.ro/">
                <i className="fa-brands fa-instagram"></i>
              </a>
              <a
                target="_blank"
                href="https://www.facebook.com/profile.php?id=61581508517817"
              >
                <i className="fa-brands fa-facebook"></i>
              </a>
              <a target="_blank" href="https://www.tiktok.com/@asempera">
                <i className="fa-brands fa-tiktok"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
